import $ from "jquery"
import UserPanelContainer, {MODE} from "../UserPanelContainer"
import Header from "./Header"
import {GROUP_NEW_OR_NOT_KNOWN, TabKeys} from "../constants"
import messageResource from "../../../messageResource"
import {ProductVersion} from "../../../constants"
import AccountCreatedContainer from "./AccountCreatedContainer"
import {getManagementAssignmentsCounters, getPassword, getPasswordCopy, getUserDataWithAdditionalData} from "../userData/selectors"
import {connect} from "../../../redux/utils"
import {bindActionCreators} from "redux"
import {
    cancelUserCreation,
    changeTeamAssignments,
    closeCreateUserPanel,
    copyUserSettings,
    deleteUserRate,
    inviteOneMoreUser,
    loadManagementAssignmentsCounts,
    onPasswordValidationEnd,
    onPasswordValidationStart,
    saveUser,
    setShowFutureInvitation,
    setUserPanelTab,
    updateAccess,
    updateAccessAP,
    updateEmail,
    updateFirstName,
    updateHireDate,
    updateInitialUserSchedule,
    updateLastName,
    updateMiddleName,
    updateOvertime,
    updatePassword,
    updateRequireApproval,
    updateTimeZoneGroup,
    updateUserGroup,
    updateUserName,
    updateUserRates,
    updateUserRights,
    updateUserSchedules,
    updateValidateUserRatesResult,
    updateValidateWorkScheduleResult,
    validateAndSaveUser
} from "./actions"
import {openEditor as openManagementAssignmentsEditor} from '../../../administration/userManagement/createUserManagementAssignmentsEditor/actions'
import {openManagementAssignmentPanel} from '../../../administration/userManagement/createManagementAssignmentsPanel/actions'
import {
    getApproversByGroupIds,
    getCopyUser,
    getSelectedTab,
    getUserPanelPasswordValidationRequested,
    isInvitationSent,
    isLoaded,
    isSaving,
    isShowFutureInvitation,
    isUserCreated
} from "./selectors"
import InvitationDialog from "../../../InvitationDialog"
import {DateFormat} from "../../../date_format"
import UserWithAccessRights from "../../../store/UserWithAccessRights"
import {setEventPreventHidingTeamAssignmentSlidingPanel} from "../../utils"
import TimeZoneGroupRow from '../components/TimeZoneGroupRow'
import UserGroupRow from '../components/UserGroupRow'
import {getLoggedInUserId} from "../../../loggedInUser/selectors"
import CreateFooter from '../../CreateFooter'
import {resetTimeZoneGroupRow, resetUserGroupRow, setTimeZoneGroupData, setUserGroupData, validateTimeZoneGroup} from '../userData/actions'
import {getAuthorizationInfo} from '../authorizationInfo/selectors'
import {getTimeZoneGroupsList, getUserGroupsList} from '../../../administration/darSettings/selectors'
import {openTeamAssignmentsPanel} from '../createTeamAssignmentsPanel/actions'
import {setUserManagementData} from '../../../administration/userManagement/common/actions'
import {getLicenseCounters, getUserManagementData} from '../../../administration/userManagement/common/selectors'
import {addDefaultUserGroup} from '../../../util/groupUtils'
import {getPasswordValidator} from '../../../util/passwords/PasswordAsyncValidator'
import {haveMoreLicenses, isLicenseUnlimited} from '../../../administration/userManagement/common/utils'

class CreateUserPanelContainer extends UserPanelContainer {

    constructor({
        actions
    }) {
        super({
            accountSettingsId: "createUserPanel",
            mode: MODE.CREATE,
            actions
        })

        this.state = {
            ...this.state,
            saving: false,
            userCreated: false,
            invitationSent: false,
            showFutureInvitation: false,
            managementAssignmentsCounts: {
                customers: 0,
                projects: 0,
                tasks: 0
            },
            needToLoadManagementAssignmentsCounts: false,
            allUsers: [],
            copyUser: null,
            approversByGroupIds: {},
            password: "",
            passwordCopy: "",
            licenseCounters: {
                actualCount: 0,
                allowedCount: 0,
                extraUsersCount: 0,
                licenseViolated: false,
                remainingCount: 1,
            }
        }

        this.onStatePropertyChanged('saving', saving => {
            this.footer.setState({saving: saving})
        })

        this.onStatePropertyChanged('userCreated', userCreated => {
            this.userPanelContentWrapper.toggle(!userCreated)
            this.accountCreatedSection.toggle(userCreated)
            this.accountCreatedOverlay.toggle(userCreated)

            if (userCreated) {
                this.accountCreatedSection.setState({
                    firstName: this.state.fullUserInfo.firstName,
                    lastName: this.state.fullUserInfo.lastName,
                    middleInitial: this.state.fullUserInfo.middleInitial,
                    email: this.state.fullUserInfo.email,
                    hireDate: this.state.fullUserInfo.hireDate,
                    invitationSent: this.state.invitationSent
                })
            }
        })

        this.onAnyStatePropertyChanged(['userCreated', 'licenseCounters'], () => {
            if (this.state.userCreated) {
                this.accountCreatedSection.setState({
                    inviteOneMoreDisabled: !isLicenseUnlimited(this.state.licenseCounters) && !haveMoreLicenses(this.state.licenseCounters)
                })
            }
        })

        this.onStatePropertyChanged('providerErrors', providerErrors => {
            if (!$.isEmptyObject(providerErrors)) {
                this.footer.setState({
                    hasErrors: true,
                })
                this.setState({selectedTab: TabKeys.ACCOUNT_SETTINGS})
                this.scrollToError(this.state.providerErrors)
            } else {
                this.footer.setState({
                    hasErrors: false
                })
            }
        })

        this.onStatePropertyBecameTrue('showFutureInvitation', () => this._showFutureInvitationDialog())

        this.onStateChanged(state => this._updateCopyUserSelector(state))

        this.onStatePropertyChanged('managementAssignmentsCounts', managementAssignmentsCounts => {
            this.permissionsTab.setState({
                managementAssignmentsCounts
            })
        })
        this.onStatePropertyBecameTrue('needToLoadManagementAssignmentsCounts', () => {
            this.actions.loadManagementAssignmentsCounts()
        })

        this.onAnyStatePropertyChanged(['approversByGroupIds', 'fullUserInfo'], ({approversByGroupIds, fullUserInfo}) => {
            this.accountSettingsTab.setState({approversList: approversByGroupIds[fullUserInfo.userGroupId]})
        })

        this.asyncPasswordValidator = getPasswordValidator({
            onValidationStart: this.actions.onPasswordValidationStart,
            onValidationEnd: this.actions.onPasswordValidationEnd
        });

        this.onStatePropertyBecameTrue("passwordValidationRequested", () => {
            let {password, passwordCopy} = this.state;
            this.asyncPasswordValidator.setState({password, passwordCopy, forcePasswordCheck: true});
        })
    }

    afterRender() {
        this.$el.attr("id", "createUserPanel");
        this.$el.addClass("createMode components_createUserPanel")
        this.$el.toggleClass("online", ProductVersion.isOlVersion)
        this.$el.toggleClass("downloadable", !ProductVersion.isOlVersion)

        this.header = new Header({
            onCopyUserSelectionCallback: this.actions.copyUserSettings,
            onCloseCallback: this.actions.cancelUserCreation,
        }).init(this.find('.panelHeader'));

        this.accountCreatedSection = new AccountCreatedContainer({
            onInviteOneMoreUserCb: () => this.actions.inviteOneMoreUser(),
            onCloseCb: () => this.actions.closeCreateUserPanel()
        }).init(this.find(".panelContent"))
        this.accountCreatedSection.hide()

        this.footer = new CreateFooter({
            submitBtnLabelMsgKey: ProductVersion.isOlVersion ? "user.add.js.create_user_with_invitation" : "user.add.js.create_user",
            onSubmitCb: () => this.actions.validateAndSaveUser(),
            onCancelCb: () => this.actions.cancelUserCreation()
        }).init(this.find(".panelFooter"))

        this.accountCreatedOverlay = $("<div class='createUserPanel_accountCreatedOverlay'/>").appendTo(this.getEl())

        super.afterRender()
    }

    subscribeForEvents() {
        super.subscribeForEvents()

        this.accountSettingsTab.accountInformation.on('changeAccessToOtherProduct', (e, enable) => {
            this.actions.updateAccessAP(enable, false)
        });
    }

    _showFutureInvitationDialog() {
        const hireDatePlaceholder = $("#createUserPanel_hireDatePlaceholder");
        const invitationDialog = new InvitationDialog().init(this.getEl());
        const formattedHireDate = new DateFormat(window.SystemSettings.dateFormat).formatDate(this.state.fullUserInfo.hireDate.parseJSONDate());
        invitationDialog.setContent(messageResource.getMessage("userlist.user_popup.confirmation.hire_date", [formattedHireDate]));
        invitationDialog.show(
            hireDatePlaceholder,
            {offset: "0 7px"},
            () => {
                this.actions.saveUser(true);
                invitationDialog.hideAndRemove();
            },
            () => {
                this.actions.onFutureInvitationDialogCancel(false)
            }
        );
    }

    _updateCopyUserSelector(state) {
        this.header.setState({
            users: state.allUsers.map(user => UserWithAccessRights.fromRPC(user)),
            userGroups: addDefaultUserGroup(state.allUserGroups),
            timeZoneGroups: state.allTimeZoneGroups,
            ugrEnabled: this.state.isUGREnabled,
            tzgEnabled: this.state.isTZGEnabled,
            isURAEnabled: this.state.isURAEnabled,
            isBTYEnabled: this.state.isBTYEnabled,
            isTTAEnabled: this.state.isTTAEnabled,
            copyUser: state.copyUser,
        });
    }

    _createUserGroupRowComponent() {
        return new UserGroupRow({
            showSaveButton: false,
            createNewUserGroup: (name) => { this.actions.updateUserGroup(GROUP_NEW_OR_NOT_KNOWN, name) },
            onGroupChanged: (id) => { this.actions.updateUserGroup(id, "") },
            updateRowDate: (data) => { this.actions.setUserGroupData(data)},
            resetGroup: () => this.actions.resetUserGroupRow(),
        })
    }

    _createTimeZoneGroupRowComponent() {
        return new TimeZoneGroupRow({
            showSaveButton: false,
            createNewGroup: (data) => { this.actions.updateTimeZoneGroup(GROUP_NEW_OR_NOT_KNOWN, data) },
            onGroupChanged: (id) => { this.actions.updateTimeZoneGroup(id, null) },
            updateRowDate: (data) => { this.actions.setTimeZoneGroupData(data)},
            resetGroup: () => this.actions.resetTimeZoneGroupRow(),
            validateTimeZoneGroup: () => this.actions.validateTimeZoneGroup(),
        })
    }

    _handleTeamAssignmentsPanelVisibility = (visible, e) => {
        this.actions.openTeamAssignmentsPanel()
        setEventPreventHidingTeamAssignmentSlidingPanel(e)
    }
}

export default connect(
    state => ({
        loggedInUserId: getLoggedInUserId(state),
        selectedTab: getSelectedTab(state),
        saving: isSaving(state),
        loaded: isLoaded(state),
        userCreated: isUserCreated(state),
        invitationSent: isInvitationSent(state),
        showFutureInvitation: isShowFutureInvitation(state),
        managementAssignmentsCounts: getManagementAssignmentsCounters(state),
        copyUser: getCopyUser(state),
        allUserGroups: getUserGroupsList(state),
        allTimeZoneGroups: getTimeZoneGroupsList(state),
        approversByGroupIds: getApproversByGroupIds(state),
        userManagementData: getUserManagementData(state),
        password: getPassword(state),
        passwordCopy: getPasswordCopy(state),
        passwordValidationRequested: getUserPanelPasswordValidationRequested(state),
        licenseCounters: getLicenseCounters(state),
        ...getUserDataWithAdditionalData(state),
        ...getAuthorizationInfo(state),
    }),
    dispatch => ({
        actions: {
            switchTab: bindActionCreators(setUserPanelTab, dispatch),
            onFutureInvitationDialogCancel: bindActionCreators(setShowFutureInvitation, dispatch),
            ...bindActionCreators({
                updateFirstName,
                updateLastName,
                updateMiddleName,
                updateUserName,
                updateEmail,
                updatePassword,
                updateUserGroup,
                setUserGroupData,
                resetUserGroupRow,
                updateTimeZoneGroup,
                validateTimeZoneGroup,
                setTimeZoneGroupData,
                resetTimeZoneGroupRow,
                updateHireDate,
                updateAccess,
                updateAccessAP,
                updateRequireApproval,
                updateUserSchedules,
                updateInitialUserSchedule,
                updateOvertime,
                updateUserRates,
                deleteUserRate,
                changeTeamAssignments,
                updateUserRights,
                saveUser,
                validateAndSaveUser,
                updateValidateUserRatesResult,
                updateValidateWorkScheduleResult,
                copyUserSettings,
                closeCreateUserPanel,
                cancelUserCreation,
                inviteOneMoreUser,
                openTeamAssignmentsPanel,
                openManagementAssignmentPanel,
                openManagementAssignmentsEditor,
                loadManagementAssignmentsCounts,
                setUserManagementData,
                onPasswordValidationStart,
                onPasswordValidationEnd,
            }, dispatch)
        }
    })
)(CreateUserPanelContainer)


// WEBPACK FOOTER //
// ./web/js/panels/user/createPanel/CreateUserPanelContainer.js